<template>
  <div class="loginPage">
    <div class="loginPage__wrapper">
      <div class="loginPage__banner"></div>
      <h1 class="loginPage__title">帳號登入</h1>
      <div class="loginPage__content">
        <input
          class="loginPage__inputField"
          id="teamcode"
          type="text"
          placeholder="車隊編號"
          v-model="team_code"
          @keyup.enter="login"
          autocomplete
        />
        <input
          class="loginPage__inputField"
          id="manageraccount"
          type="text"
          placeholder="使用者帳號"
          v-model="account"
          @keyup.enter="login"
          autocomplete
        />
        <input
          class="loginPage__inputField"
          id="managerpassword"
          type="password"
          placeholder="使用者密碼"
          v-model="password"
          @keyup.enter="login"
          autocomplete
        />
        <button class="loginPage__button" @click="login">登入</button>
      </div>
      <div class="loginPage__footer">
        <h1 class="loginPage__title">GLAD Taxi 享受生活</h1>
        <p>©2018-{{ untilYear }} 資通行動科技有限公司{{ VERSION }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/assets/js/libs/API'
import dayjs from 'dayjs'
import EnterpriseAPI from '@/assets/js/libs/EnterpriseAPI'
import { cookies, initLoginCookies } from '@/utils/cookies'
import { appVersion } from '@/constants/general'
import updateKml from '@/assets/js/tool/updateKml'
import managerService from '@/API/managerService'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'

export default {
  name: 'Login',
  data() {
    return {
      member: 'manager',
      team_code: '',
      account: '',
      password: '',
      untilYear: dayjs().year(),
      VERSION: appVersion,
    }
  },
  mounted() {
    // 先清空localStorage中kml的資料
    localStorage.clear()
    if (cookies.get('user')) {
      this.$router.replace({ name: 'Board' })
    }
  },
  methods: {
    async login() {
      if (this.account === '' || this.password === '' || this.team_code === '')
        return alert('請輸入資料')
      try {
        const { result } = await managerService.login({
          account: this.account.trim(),
          password: this.password,
          teamCode: this.team_code,
        })
        initLoginCookies(result)
        API.defaults.headers.common['x-access-token'] = result.token
        EnterpriseAPI.defaults.headers.common['x-access-token'] = result.token
        // 將 teamRoles 存到 Vuex
        if (result.teamRoles) {
          this.$store.commit('managerStore/SET_TEAM_ROLES', result.teamRoles)
        }
        // 成功登入後，將kml資訊設置在local storage
        updateKml.getAllShiftArea()
        updateKml.getAllDispatchArea()
        this.$router.replace({ name: 'Board' })
        BehaviorRecorder.record('點擊', '登入畫面', '登入成功')
      } catch (e) {
        alert('帳號密碼錯誤')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_loginPage.scss';
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue